import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import { SettingsColor } from '../presentationSettings';
import { adminSelectSx } from './adminFormSx';

interface AdminColorSelectProps {
  id?: string;
  value: string;
  colors: SettingsColor[];
  onChange: (id: string) => void;
  describedBy?: string;
  fullWidth?: boolean;
}

const AdminColorSelect: React.FC<AdminColorSelectProps> = ({
  id,
  value,
  colors,
  onChange,
  describedBy,
  fullWidth,
}) => {
  const options = colors.filter((color) => !color.hidden || color.id === value);
  return (
    <Select
      id={id}
      size="small"
      fullWidth={fullWidth}
      value={options.some((color) => color.id === value) ? value : (options[0]?.id || '')}
      onChange={(event) => onChange(event.target.value)}
      inputProps={{ 'aria-describedby': describedBy }}
      sx={adminSelectSx()}
    >
      {options.map((color) => (
        <MenuItem key={color.id} value={color.id}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: '50%',
                bgcolor: color.hex,
                border: `1px solid ${PRES.borderStrong}`,
                flexShrink: 0,
              }}
            />
            <Box component="span" sx={{ fontFamily: TYPE.ui, ...TYPE.body }}>{color.name}</Box>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default AdminColorSelect;
